import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import { Modal } from '@mui/material';
import { TextField, Button } from '@mui/material'


import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import CloseIcon from '@mui/icons-material/Close';

import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import AppsIcon from '@mui/icons-material/Apps';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import OutboxIcon from '@mui/icons-material/Outbox';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';



import { useNavigate } from "react-router-dom";

import logo from "../img/logo_transparent.png"



const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function Sidebar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [openM, setOpenM] = React.useState(false);
  const [pass, setpass] = React.useState("")
  const [nav, setnav] = React.useState("")

  const handleOpen = () => setOpenM(true);
  const handleClose = () => setOpenM(false);

  React.useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
      } else {
        navigate("/");
      }
    });
  }, [])
  



  const handleDrawerClose = () => {
    setOpen(false);
  };


  const navStaff = (a) => {

    handleOpen()
    setnav(a)

  };

  function navNext() {

    if (pass === "brianstella") {
      navigate(nav);
      setpass("")
    } else {
      alert("Enter Correct Password");
      return
    }
    handleClose()
    setpass("")

  }

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Modal */}

      <Modal
        open={openM}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: '#ffffff',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Button onClick={() => handleClose()} style={{ position: "absolute", right: "0", }}><CloseIcon /></Button>
          <div className="LoginPage" style={{ height: "50vh" }}>
            <h3 style={{ color: "red" }}>
              You are trying to access a protected area of the Moses Project system.
              Please enter the password or speak with Brian or Stella.
            </h3>
            <TextField type="password" label="Password" className='addform' style={{ width: "100%" }} id="outlined-basic" variant="outlined" value={pass} onChange={(e) => setpass(e.target.value)} />
            <Button onClick={navNext} className='addform' variant="outlined" style={{ marginTop: "30px", width: "100%", color: "#F21D2F" }}>Enter</Button>
          </div>
        </Box>
      </Modal>


      <CssBaseline />

      <Drawer variant="permanent" open={open} PaperProps={{
        sx: {
          backgroundColor: "#8DBF41",
          color: "white",
        }
      }}>
        <List>
          <ListItem key={"Home"} disablePadding sx={{ display: 'block' }} onClick={() => navigate("/home")}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <HomeIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary={"Home"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
            </ListItemButton>
          </ListItem>
        </List>

        <List>
          <ListItem key={"addNew"} disablePadding sx={{ display: 'block' }} onClick={() => navigate("/addnew")}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <AddIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary={"Add New Beneficiary"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
            </ListItemButton>
          </ListItem>
        </List>
        <List>
          <ListItem key={"viewall"} disablePadding sx={{ display: 'block' }} onClick={() => navigate("/viewall")}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <AppsIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary={"View All Beneficiary"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
            </ListItemButton>
          </ListItem>
        </List>
        <List>
          <ListItem key={"archive"} disablePadding sx={{ display: 'block' }} onClick={() => navigate("/archived")}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <OutboxIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary={"Archived Beneficiary"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
            </ListItemButton>
          </ListItem>
        </List>
        <List>
          <ListItem key={"dailySumbission"} disablePadding sx={{ display: 'block' }} onClick={() => navigate("/dailySumbissions")}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
              >
                <AutoStoriesIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary={"Daily Submissions"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
            </ListItemButton>
          </ListItem>
        </List>
        <div style={{ backgroundColor: "#0cacec" }}>
          <List>
            <ListItem key={"addNewStaff"} disablePadding sx={{ display: 'block' }} onClick={() => {
              navStaff("/addnewStaff")


            }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <AddIcon sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary={"Add New Staff"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
              </ListItemButton>
            </ListItem>
          </List>
          <List>
            <ListItem key={"viewAllStaff"} disablePadding sx={{ display: 'block' }} onClick={() => {

              navStaff("/viewallStaff")

            }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <AppsIcon sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary={"View All Staff"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
              </ListItemButton>
            </ListItem>
          </List>
          <List>
            <ListItem key={"archiveStaff"} disablePadding sx={{ display: 'block' }} onClick={() => {

              navStaff("/archivedStaff")


            }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <OutboxIcon sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary={"Archived Staff"} sx={{ opacity: open ? 1 : 0, color: "white", }} />
              </ListItemButton>
            </ListItem>
          </List>
        </div>
        <div className='LogoPanelSidebar' style={{ height: "20vh", paddingTop: "100px", }}>
          <img src={logo} height="120" style={{ marginBottom: "80px" }} />
        </div>

      </Drawer>

    </Box>
  );
}